var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41758 6.3002C7.67591 3.3002 9.21758 2.0752 12.5926 2.0752H12.7009C16.4259 2.0752 17.9176 3.56686 17.9176 7.29186V12.7252C17.9176 16.4502 16.4259 17.9419 12.7009 17.9419H12.5926C9.24258 17.9419 7.70091 16.7335 7.42591 13.7835M13.001 10.0002L10.5012 8.00018M13.001 10.0002L10.5012 12.0002M13.001 10.0002L7.75924 10.0002H3.01758",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.38ebb62ff3310c47737123172a0a3549.svg";
export { ForwardRef as ReactComponent };